var styleDataHash = "d62bf881";
const injectCss = (() => {
  var css = `.mZSPv{margin-left:0;margin-right:auto;z-index:1}.mZSPv:not(.X1QM4){float:left;margin-right:40px}@supports not (contain:inline-size){@media only screen and (max-width:480px){.mZSPv:not(.X1QM4){float:none;margin-right:auto}}}@container (width < 480px){.mZSPv:not(.X1QM4){float:none;margin-right:auto}}.rCrku{margin-left:auto;margin-right:0;z-index:1}.rCrku:not(.X1QM4){float:right;margin-left:40px}@supports not (contain:inline-size){@media only screen and (max-width:480px){.rCrku:not(.X1QM4){float:none;margin-left:auto}}}@container (width < 480px){.rCrku:not(.X1QM4){float:none;margin-left:auto}}.dMAxx{clear:both;display:block}.dMAxx:not(.WruJc){margin-left:auto;margin-right:auto;max-width:100%}.WruJc,.X1QM4{width:100%}.-dHCE .WruJc,.-dHCE .X1QM4{margin:0 -8px;width:auto}._4ichO{width:fit-content}.o8o27{margin-left:auto;margin-right:auto;max-width:100%}.BwkVc{width:min(350px,100%)!important}.-dHCE .BwkVc{width:50%}.M-alP{margin-left:auto;margin-right:auto}.-dHCE .M-alP{width:150px}.UgoQv{display:flex}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var general_default = {
  "alignLeft": "mZSPv",
  "textWrapNowrap": "X1QM4",
  "alignRight": "rCrku",
  "alignCenter": "dMAxx",
  "sizeFullWidth": "WruJc",
  "renderedInTable": "-dHCE",
  "sizeOriginal": "_4ichO",
  "sizeContent": "o8o27",
  "sizeSmall": "BwkVc",
  "sizeSmallCenter": "M-alP",
  "flex": "UgoQv"
};
export {
  general_default as default,
  injectCss
};
//# sourceMappingURL=general-scss.js.map
